<div class="close">
  <div style="margin-right: auto !important; cursor: pointer" (click)="close()">
    <img class="close-icon" src="assets/images/close-icon.svg" />
  </div>
</div>
<div class="content">
  <div class="icon">
    <img class="error-icon" src="assets/images/error-icon.svg" />
  </div>
  <div class="title ic1-text-secondary">{{ title }}</div>
  <div class="error-message ic1-text-secondary" [innerHTML]="errorMessage"></div>
  <div
    class="error-code"
    [innerHTML]="
      'ERROR_MODAL.ERROR_CODE'
        | translate
          : {
              errorCode: correlationId
            }
    "></div>
  <div class="error-modal-actions">
    <button
      *ngIf="isNtf002Error"
      type="button"
      class="ic1-btn ic1-btn-sm ic1-btn-primary"
      [attr.aria-label]="'ERROR_MODAL.CHANGE_USER_BUTTON' | translate"
      (click)="changeUser()">
      <span [translate]="'ERROR_MODAL.CHANGE_USER_BUTTON'"></span>
    </button>
    <button
      *ngIf="isNtf002Error"
      type="button"
      class="ic1-btn ic1-btn-sm ic1-btn-secondary"
      [attr.aria-label]="'ERROR_MODAL.CONTACT_SUPPORT_BUTTON' | translate"
      (click)="contactSupport()">
      <span [translate]="'ERROR_MODAL.CONTACT_SUPPORT_BUTTON'"></span>
    </button>
  </div>
</div>
